module.exports = __webpack_public_path__ + "static/media/ripple.3044b9b3.svg";